import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import { FaShoppingCart } from "react-icons/fa";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      {/* Top Banner */}
      <div className="top-banner">
        <p>ATTENTION: Canada Post shipping is temporarily unavailable.</p>
      </div>

      {/* Main Header */}
      <div className="main-header">
        <div className="header-container">
          <div className="logo-section">
            <Link to="/" onClick={toTop} className="logo-link" aria-label="hetcratehub home">
              <img
                src="/brand/hetcratehub-logo.svg"
                alt="hetcratehub"
                className="brand-logo"
              />
            </Link>
          </div>

          {/* Contact & Auth */}
          <div className="contact-section">
            <div className="contact-info">
              <span className="contact-desc">Questions? We're here to help</span>
              <a className="contact-email" href="mailto:group@hetcratehub.today">
                group@hetcratehub.today
              </a>
            </div>
            <Link to="/cartpage" className="cart-link" onClick={toTop}>
              <FaShoppingCart className="cart-icon" />
              {cartItems && cartItems.length > 0 && (
                <span className="cart-count">{cartItems.length}</span>
              )}
            </Link>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="main-nav">
        <div className="nav-container">
          <ul className="nav-list">
            <li>
              <Link to="/shop" onClick={toTop}>
                SALE
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={toTop}>
                ABOUT US
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={toTop}>
                CONTACT
              </Link>
            </li>
            <li className="more-menu">
              <details>
                <summary>MORE</summary>
                <ul className="more-dropdown">
                  <li><Link to="/privacy" onClick={toTop}>Privacy Policy</Link></li>
                  <li><Link to="/terms" onClick={toTop}>Terms &amp; Conditions</Link></li>
                  <li><Link to="/cookies" onClick={toTop}>Cookie Policy</Link></li>
                  <li><Link to="/faq" onClick={toTop}>FAQs</Link></li>
                  <li><Link to="/accessibility" onClick={toTop}>Accessibility</Link></li>
                  <li><Link to="/returns" onClick={toTop}>Returns &amp; Exchanges</Link></li>
                </ul>
              </details>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default Header;
